import { PRICE_RANGES } from "../../constants/metrics.constants"
import { ICalcTargetCPC } from "../../types/metrics.types"

export function minMaxValidation(value: number, min: number, max: number): number {
  if (value < min) {
    return min
  }
  if (value > max) {
    return max
  }
  return value
}

export function calcTargetCPC(params: ICalcTargetCPC): number {
  const {
    targetAcos,
    orders,
    impressions,
    aovValue,
    clicks,
    bidInAmazon,
    currentAcos,
    sales,
    defaultBid,
  } = params

  if (!bidInAmazon) {
    return defaultBid
  }

  const CVR =
    PRICE_RANGES.find((range) => range.from <= aovValue && range.to >= aovValue)?.cvr ||
    PRICE_RANGES[0].cvr
  if (orders === 0 && impressions > 100) {
    const targetCPC = Math.min(
      aovValue * (targetAcos / 100) * (CVR / 100),
      aovValue * (targetAcos / 100) * (1 / (clicks + 1))
    )
    return Number(targetCPC?.toFixed(2))
  }

  if (orders === 0 && impressions <= 100) {
    const targetCPC = bidInAmazon * 1.05
    return Number(targetCPC?.toFixed(2))
  }

  if (orders >= 1 && orders <= 3 && currentAcos < 100) {
    return Number(bidInAmazon.toFixed(2))
  }

  if ((orders === 4 || orders === 5) && currentAcos < 50) {
    return Number(bidInAmazon.toFixed(2))
  }

  if (clicks === 0) {
    return Number(bidInAmazon.toFixed(2))
  }
  const targetCPC = (sales / clicks) * (targetAcos / 100)
  return Number(targetCPC.toFixed(2))
}
